export const MONTHLY_MOBILE_WIDTH = 580.5;
